export default __webpack_public_path__ + "static/media/Renata.9bd8085a.png";